import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import WrapPage from '@/components/base/Layout/wrap';
import EmptyCard from '@/components/base/EmptyCard';
import useLanguage from '@/hooks/useLanguage';
import Extra from '@/components/combined/TransactionListExtra';
import TransactionTitleTip from '@/components/combined/TransactionTitleTip';
import { useRouter } from 'next/router';
import TransactionTable from '@/components/combined/TransactionList';
var TransactionList = function() {
    var translate = useLanguage().translate;
    var router = useRouter(); // const defaultShardFromQuery = router.query?.s as string
    var ref = useState(), shard = ref[0], chooseShard = ref[1];
    var ref1 = useState(0), total = ref1[0], setTotal = ref1[1];
    var onShardChange = useCallback(function(item) {
        chooseShard(String(item));
    }, []);
    return(/*#__PURE__*/ _jsx(EmptyCard, {
        title: /*#__PURE__*/ _jsx(TransactionTitleTip, {
            title: translate('Transaction History')
        }),
        titleClassName: "text-[24px] h-[36px] flex",
        className: "mt-[20px] text-[24px]",
        righter: /*#__PURE__*/ _jsx(Extra, {
            total: total,
            defaultShard: '',
            onShardChange: onShardChange
        }),
        children: /*#__PURE__*/ _jsx(TransactionTable, {
            shard: shard,
            showType: true,
            onTotalChange: setTotal
        })
    }));
};
export default WrapPage(TransactionList);
